const tpl = require('./templates/t_itv_edit_delete_icon.hbs');

define(function (require) {
	return Marionette.ItemView.extend({
		template: tpl,
		config: {},
		tagName: 'td',//will only be displayed in table, no need to determine tag name dynamically
		ui: {
			deleteButton: '.btn-row-delete',
			editButton: '.btn-row-edit'
		},
		events: {
			'click @ui.deleteButton': 'deleteClicked',
			'click @ui.editButton': 'editClicked'
		},
		initialize: function (options) {
			this.config = options.config;
			this.editIcon = (this.model.get('type') == 'edit' && this.model.get('showEdit'));
			this.deleteIcon = (this.model.get('type') == 'delete' && this.model.get('showDelete'));
		},
		className: function () {
			if (this.model) {
				if (this.model.get('type') == 'edit') {
					return 'grid-data edit';
				} else if (this.model.get('type') == 'delete') {
					return 'grid-data delete';
				}
			}
			return 'unknown-hidden-td'
		},
		onRender: function () {
		},
		templateHelpers: function () {
			return {
				edit: this.editIcon,
				delete: this.deleteIcon
			};
		},
		//Marionette Functions End
		deleteClicked: function (e) {
			e.preventDefault();
			e.stopPropagation();
			//just some quick error prevention. We shouldn't be able to delete a row if the button isn't showing.
			if (this.model.get('showDelete')) {
				this.triggerMethod('deleteClicked');
			}
		},
		editClicked: function (e) {
			e.preventDefault();
			e.stopPropagation();
			//just some quick error prevention. We shouldn't be able to edit a row if the button isn't showing.
			if (this.model.get('showEdit')) {
				this.triggerMethod('editClicked');
			}
		},
	});
});

